define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Room = (function () {
        function Room() {
            this.LocationId = "";
            this.Name = "";
            this.Comment = "";
            this.VirtualScreenIds = [];
            this.VirtualScreens = [];
        }
        return Room;
    }());
    exports.Room = Room;
});
//# sourceMappingURL=Room.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Room.js
// module id = 160
// module chunks = 0